import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_EMBED,
  ELEMENT_IMAGE,
  ELEMENT_INLINE_IMAGE,
  ELEMENT_INTERLINK,
  ELEMENT_LINK,
  ELEMENT_OL,
  ELEMENT_PARAGRAPH,
  ELEMENT_TABLE,
  ELEMENT_UL,
  ELEMENT_VIDEO_EMBED,
  MyRootBlock,
  MyValue,
  MyValueTypes,
} from '../plateTypes';
import { makeNodeId } from '../utils/nodeId';
import type { ArticleStructure } from './types';

/**
 * Is the current article empty?
 *
 * @param doc
 */
export const isEmptyDocument = (doc: MyValue): boolean => {
  if (doc.length === 0) return true;
  if (doc.length > 1) return false;
  if (doc[0].type !== 'p') return false;
  if (doc[0].children.length === 0) return true;
  if (doc[0].children.length > 1) return false;
  if (
    typeof doc[0].children[0].text === 'string' &&
    doc[0].children[0].text.length === 0
  )
    return true;
  return false;
};

/**
 * Slate needs a minimum document to start with otherwise it crashes. This gets
 * you that.
 *
 * @returns
 */
export const getEmptyValue = (): MyValue => {
  return [
    {
      id: makeNodeId(),
      type: ELEMENT_PARAGRAPH,
      children: [{ text: '' }],
    },
  ];
};

/**
 * Minimum viable document structure (see: getEmptyValue). Used in create
 * article
 *
 * @returns
 */
export const getEmptyStructure = (): ArticleStructure => {
  return {
    version: '1.3.0',
    children: getEmptyValue(),
  };
};

export const createEmptyBlock = (type: MyValueTypes): MyRootBlock => {
  if (type === ELEMENT_UL || type === ELEMENT_OL) {
    return {
      id: makeNodeId(),
      type,
      children: [
        {
          id: makeNodeId(),
          type: 'li',
          children: [
            {
              id: makeNodeId(),
              type: 'lic',
              children: [{ text: '' }],
            },
          ],
        },
      ],
    };
  }

  if (type === ELEMENT_IMAGE) {
    return {
      id: makeNodeId(),
      type,
      url: null,
      filename: null,
      imgAlign: 'center',
      caption: [{ text: '' }],
      children: [{ text: '' }],
    };
  }

  if (type === ELEMENT_VIDEO_EMBED) {
    return {
      id: makeNodeId(),
      type,
      url: null,
      align: 'stretch',
      caption: [{ text: '' }],
      children: [{ text: '' }],
    };
  }

  if (type === ELEMENT_EMBED) {
    return {
      id: makeNodeId(),
      type,
      src: null,
      children: [{ text: '' }],
    };
  }
  // this is handled via Plates insertTable
  if (type === ELEMENT_TABLE) {
    return {} as never;
  }

  // Inline elements, created elsewhere
  if (
    type === ELEMENT_INLINE_IMAGE ||
    type === ELEMENT_INTERLINK ||
    type === ELEMENT_LINK ||
    type === ELEMENT_ANCHOR_LINK
  ) {
    return {} as never;
  }

  return {
    id: makeNodeId(),
    type,
    children: [{ text: '' }],
  };
};
